"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvenFixedInstallmentPlanEligibilityResult = exports.AmortizationLoanPlanType = exports.ALLOWED_AMORTIZATION_LOAN_TYPES = exports.AmortizationLoanType = void 0;
var AmortizationLoanType;
(function (AmortizationLoanType) {
    AmortizationLoanType["fixedFinanceCharge"] = "fixedFinanceCharge";
    AmortizationLoanType["simpleInterest"] = "simpleInterest";
    AmortizationLoanType["fixedInterestOnly"] = "fixedInterestOnly";
    AmortizationLoanType["none"] = "none";
})(AmortizationLoanType || (exports.AmortizationLoanType = AmortizationLoanType = {}));
exports.ALLOWED_AMORTIZATION_LOAN_TYPES = Object.values(AmortizationLoanType).filter((type) => type !== AmortizationLoanType.fixedFinanceCharge);
var AmortizationLoanPlanType;
(function (AmortizationLoanPlanType) {
    AmortizationLoanPlanType["cashOut"] = "Cash Out";
    AmortizationLoanPlanType["balanceTransfer"] = "Balance Transfer";
    AmortizationLoanPlanType["internalPlanTransfer"] = "Plan";
    AmortizationLoanPlanType["stateRecordingCharge"] = "State Recording Charge";
    AmortizationLoanPlanType["cashToMerchant"] = "Cash To Merchant";
    AmortizationLoanPlanType["stateSigningCharge"] = "State Signing Charge";
})(AmortizationLoanPlanType || (exports.AmortizationLoanPlanType = AmortizationLoanPlanType = {}));
var AvenFixedInstallmentPlanEligibilityResult;
(function (AvenFixedInstallmentPlanEligibilityResult) {
    AvenFixedInstallmentPlanEligibilityResult["ENABLED"] = "ENABLED";
    AvenFixedInstallmentPlanEligibilityResult["DISABLED_DUE_TO_TEASER"] = "DISABLED_DUE_TO_TEASER";
    AvenFixedInstallmentPlanEligibilityResult["DISABLED_DUE_TO_HCM"] = "DISABLED_DUE_TO_HCM";
    AvenFixedInstallmentPlanEligibilityResult["DISABLED_DUE_TO_PENDING_PRIME_V2_OPT_OUT"] = "DISABLED_DUE_TO_PENDING_PRIME_V2_OPT_OUT";
    AvenFixedInstallmentPlanEligibilityResult["DISABLED_DUE_TO_PRODUCT"] = "DISABLED_DUE_TO_PRODUCT";
    AvenFixedInstallmentPlanEligibilityResult["DISABLED_DUE_TO_INADEQUATE_AMOUNT"] = "DISABLED_DUE_TO_INADEQUATE_AMOUNT";
    AvenFixedInstallmentPlanEligibilityResult["DISABLED_DUE_TO_FLAG_CHECK"] = "DISABLED_DUE_TO_FLAG_CHECK";
})(AvenFixedInstallmentPlanEligibilityResult || (exports.AvenFixedInstallmentPlanEligibilityResult = AvenFixedInstallmentPlanEligibilityResult = {}));
